import { OnInit } from "@angular/core";
import { Field } from "../models/field.model";
import { ENVIRONMENT } from "../../../../environments/environment";
export class FormSelectMultipleCheckComponent extends Field {
    constructor() {
        super(...arguments);
        this.STR_route_to_self = "";
        /**
         * Attributes
         */
        // Settings configuration
        this.settings = {
            id: "id",
            text: "title",
            enableFilter: true,
            placeholder: "please_select",
            filterPlaceholder: "filter",
            multiple: false,
            options: null
        };
    }
    /**
     * Function > ngOnInit
     * @return {any}
     */
    ngOnInit() {
        // console.log("Initializing form-select-multiple-check", this.OBJ_field_config);
        this.settings.multiple = (this.OBJ_field_config.multiple != null) ? this.OBJ_field_config.multiple : true;
        this.settings.options = (this.OBJ_field_config._links.options != null) ? this.OBJ_field_config._links.options : null;
        // If this is an assignment offer the user a link to the assigned object
        if (this.OBJ_field_config.object_structure &&
            this.OBJ_field_config.object_structure.classname.includes("ImageAssignment") &&
            this.OBJ_field_config.value.length > 0) {
            let STR_url = "";
            if (ENVIRONMENT.env === 'development') {
                STR_url = 'wcms/';
            } // end if
            if (this.OBJ_field_config.object_structure.classname.includes("ImageAssignment")) {
                this.STR_route_to_self = STR_url + 'upload/images/' + this.OBJ_field_config.value[0];
            }
            else if (this.OBJ_field_config.object_structure.classname.includes("FileAssignment")) {
                this.STR_route_to_self = STR_url + 'upload/files/' + this.OBJ_field_config.value[0];
            } // end if
        } // end if
    } // end function ngOnInit
    /**
     * Function > selected
     * @param {object} OBJ_value
     */
    selected(OBJ_value) {
        this.OBJ_field_config.value = OBJ_value;
        this.markAsDirtyAndTouched();
    } // end function selected
} // end class FormSelectMultipleCheckComponent
